import React from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { Box, Chip, Grid, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        chip: {
            borderRadius: 6,
            color: "white",
            backgroundColor: "#2196f3",
            padding: 4
        }
    });
});

export const JobReportsTypeToRender: CompleoShared.Reports.IJobReportsToRender[] = [
    "funnel",
    "dashboard",
    "activities",
    "activitiesRecruiter"
];

interface IJobReportTitle {
    type: CompleoShared.Reports.IJobReportsToRender;
    t: any;
}

const JobReportTitle = (props: IJobReportTitle) => {
    const classes = useStyles();
    const { t, type } = props;

    return (
        <Box ml={0}>
            {" "}
            <Chip
                className={classes.chip}
                size="medium"
                label={
                    <Typography component="p" variant="body1">
                        <strong>{t(`reportTitle_${type}`)}</strong>
                    </Typography>
                }
            />
        </Box>
    );
};

export default JobReportTitle;
